export default {
  title: 'New Employee form',
  type: 'object',
  properties: {
    email: {
      type: 'string',
      format: 'email',
      title: 'Email',
      fieldRequired: 'true',
      validationMessages: {
        required: 'Wpisz adres e-mail',
        format: 'Podaj poprawny adres email'
      }
    },
    firstName: {
      type: 'string',
      format: 'string',
      title: 'Imię',
      fieldRequired: 'true',
      validationMessages: {
        required: 'Wpisz imię nowego pracownika'
      }
    },
    lastName: {
      type: 'string',
      format: 'string',
      title: 'Nazwisko',
      fieldRequired: 'true',
      validationMessages: {
        required: 'Wpisz nazwisko nowego pracownika'
      }
    },
    password: {
      type: 'string',
      format: 'string',
      title: 'Hasło',
      fieldRequired: 'false',
      minLength: 8,
      validationMessages: {
        required: 'Utwórz hasło nowego pracownika'
      }
    },
    repeatPassword: {
      type: 'string',
      format: 'string',
      title: 'Powtórz hasło',
      fieldRequired: 'false',
      validFunc: 'this.password !== this.repeatPassword? "Hasła muszą być identyczne": true',
      validationMessages: {
        required: 'Powtórz hasło',
        format: 'Hasła muszą być identyczne'
      }
    }
  }
};
